// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-answer-card-result-default__btn__wrap--score{text-align:center;margin-bottom:20px}.plv-iar-answer-card-result-default__footer{padding:17px 0 24px;text-align:center}.plv-iar-answer-card-result-default__other__result{padding:20px 25px 25px;box-sizing:border-box}.plv-iar-answer-card-result-default__correction{border-bottom:1px solid #eceff1;margin-bottom:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
